import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PathTestMapPoint, PathTestPoint, PathTestPointSeq } from '../../../core/models';
import { AppState, ShowRequest } from '../../../core';
import { PathTestDoc } from '../../../core/schema/path-test-schema';
import { UserService } from '../../../core/services';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DialerClientTestSeqModalComponent } from '../../../dialer-client/dialer-client-testseq/dialer-client-testseq-modal/dialer-client-testseq-modal.component';

//
// Popup for clicking on marker
//
@Component({
  templateUrl: './path-test-point-marker-popup.component.html',
  styleUrls: ['./path-test-point-marker-popup.component.scss'],
  viewProviders: [ CommonModule]
})
export class PathTestPointMarkerPopupComponent implements OnInit {

  @Input() pt : PathTestMapPoint;
  @Input() selectedPt : PathTestMapPoint;
  @Input() pathTestDoc : PathTestDoc;
  @Input() bShowSelectButton : boolean
  @Input() setSelectedPointFn : ( pt : PathTestMapPoint ) => void
  @Input() deleteScoutPointFn : ( pt : PathTestMapPoint ) => void
  @Input() allowEditMode : boolean = true
  @Input() changeGuard : (current: PathTestMapPoint, acceptFn: ()=>void) => void = (c,a) => a()
  @Input() showRefDataFn : ( pt : PathTestMapPoint ) => void
  @Input() locked : boolean
  //@Input() scoutPathChangedFn : () => void
  strLat : string
  strLng : string
  testPoint: PathTestPoint
  seq: PathTestPointSeq
  userName$ : Observable<string>
  testResultsModalRef?: BsModalRef;
  testPointCnt: number

  constructor( protected appState: AppState,
    protected userService: UserService,
    private modalService: BsModalService ) {

  }

  ngOnInit() {
    this.strLat = this.pt.latitude ? Number(this.pt.latitude).toFixed(6) : ''
    this.strLng = this.pt.longitude ? Number(this.pt.longitude).toFixed(6) : ''
    this.testPoint = this.pt.pathTestPoint
    this.testPointCnt = this.pathTestDoc?.testPoints?.length
    this.seq = this.testPoint?.seqs.last()
    if ( this.seq?.userId ) {
      this.userName$ = from(this.userService.getById(this.seq.userId))
        .pipe( map( userDoc=> userDoc ? `${userDoc.firstName} ${userDoc.lastName}` : ''))
    }
  }


  openExternalUrl(url:string) {
    if ( this.appState.isElectron() ) {
      const shell = window.require('electron').shell;
      shell?.openExternal(url)
    } else {
      window.open( url, `Path Test Point ${this.pt.name}` );
    }
  }

  onShowGoogleMapsPoint(lat:string,lng:string) {
    this.openExternalUrl(`https://www.google.com/maps/place/${lat},${lng}/@${lat},${lng},21z`)
  }

  onSelectPoint = () => {
    console.log('onSelectPoint' + this.pt.name)
    this.setSelectedPointFn(this.pt)
  }

  onShowRefData = () => {
    this.showRefDataFn(this.pt)
  }

  onShowPoint = ( pointId : string ) => {
    this.appState.showView.next( new ShowRequest('tab','point', pointId) )
  }

  onShowTestResults() {

    const initialState = {
      seqContext: { seq: this.seq, type: this.pathTestDoc.type }
    }
    this.testResultsModalRef =
        DialerClientTestSeqModalComponent.showModal(this.modalService, initialState)
    this.testResultsModalRef.onHide.subscribe( _ => {
      this.testResultsModalRef = null
    })

  }
}